import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template", "row", "position", "destroy"]

  add() {
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now().toString())
    this.listTarget.insertAdjacentHTML("beforeend", content)
    this.dispatchChanged()
  }

  remove(event) {
    const row = event.target.closest('[data-routine-blocks-target="row"]')
    if (!row) return

    if (row.dataset.persisted === "true") {
      row.querySelector('[data-routine-blocks-target="destroy"]').value = "1"
      row.classList.add("hidden")
    } else {
      row.remove()
    }

    this.dispatchChanged()
  }

  dispatchChanged() {
    this.element.dispatchEvent(new CustomEvent("routine-blocks:changed", { bubbles: true }))
  }
}
